import React, { useState, useEffect } from 'react';
// @material-ui/core components
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteIcon from '@material-ui/icons/Delete';
import Pagination from '@material-ui/lab/Pagination';
import { Link } from 'react-router-dom';
import {
  Table,
} from 'reactstrap';
import { makeStyles } from '@material-ui/core/styles';
// core components
import { connect } from 'react-redux';
import { getAllEvents, deleteDiscount } from '../../store/actions/admin/Admin';
import CardHeader from '../../components/Card/CardHeader.js';
const PAGE_LIMIT = 2000
const styles = {
  typo: {
    paddingLeft: '25%',
    marginBottom: '40px',
    position: 'relative'
  },
  note: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    bottom: '10px',
    color: '#c0c1c2',
    display: 'block',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '13px',
    left: '0',
    marginLeft: '20px',
    position: 'absolute',
    width: '260px'
  },
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0'
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none'
  }
};

const useStyles = makeStyles(styles);

const AllEventsTable = (props) => {
  const classes = useStyles();
  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [page, setPage] = useState(1);

  const toggle = () => setModal(!modal);
  const toggle2 = () => setModal2(!modal2);

  const [itemDelete, setItemDelete] = useState(0);

  useEffect(() => {
    props.getAllEvents(1);
  }, []);

  const handleDelete = (id) => {
    props.deleteDiscount(id).then((data) => {
      if (data) {
        props.getAllEvents(1);
      }
    });
  };
  const handlePagination = (event, value) => {
    setPage(value);
    props.getAllEvents(value);
  };
  return (
    <>
      <CardHeader color="primary">
        <h4 className={classes.cardTitleWhite}>
          All Events
        </h4>
      </CardHeader>
      <Table hover>
        <thead>
          <tr>
            <th>#</th>
            <th>IP</th>
            <th>Created At</th>
            <th>Last Active</th>
            <th>Country</th>
            <th>View</th>
          </tr>
        </thead>
        <tbody>
          {props.allEvents?.map((item, i) => (
            <tr key={item._id}>
              <th scope="row">{i + 1 + (page ? (page - 1) * PAGE_LIMIT : 0)}</th>
              <td>{item._id}</td>
              <td>{new Date(parseInt(item.createdAt)).toLocaleString()}</td>
              <td>{new Date(parseInt(item.lastActive)).toLocaleString()}</td>
              <td>{item.country}</td>
              <td>
                <Link
                  style={{ color: '#000' }}
                  to={'/admin/view-event/' + item._id}
                >
                  <VisibilityIcon />
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};

const mapStateWithProps = (state) => ({
  allEvents: state.admin.allEvents,
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getAllEvents: (id) => dispatch(getAllEvents(id, PAGE_LIMIT)),
  };
};

export default connect(mapStateWithProps, mapDispatchWithProps)(AllEventsTable);
